export const TRIGGER_FEED_FILTERS_MODAL = "triggerFeedFiltersModal";
export const FORCE_REFRESH_FEED = "forceRefreshFeed";
export const REFRESH_CHAT_TIMESTAMP = "refreshChatTimestamp";
export const WS_PING_RECEIVED = "wsPingReceived";
export const REMOVE_FROM_FEED_KEEP_THREAD_OPEN = "removeFromFeedKeepThreadOpen";
export const EMBED_THREAD_FROM_CMDK = "embedThreadFromCmdK";
export const TRIGGER_NOTIFICATION = "triggerNotification";
export const REALTIME_RECONNECTION_TRIGGERED = "realtimeReconnectionTriggered";
